module.exports = __webpack_public_path__ + "img/10-9.219ff259.jpg";